// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/VirusPage/VirusPage.css
// module id = 963
// module chunks = 0